
import { CSSProperties } from "@mui/material";

export const table_thead: CSSProperties = {
    backgroundColor: '#000',
    color: '#ffffff',
    textAlign: 'left',
}

export const table_padding: CSSProperties = {
    padding: '12px 15px',
}

export const table_tbody: CSSProperties = {
    borderBottom: '1px solid #dddddd',
    backgroundColor: '#f5f5f5',
}
